import axios from 'axios'
import qs from 'qs'
axios.interceptors.request.use(config => {
  return config
}, error => {
  return Promise.reject(error)
})
axios.interceptors.response.use(response => response, error => Promise.resolve(error.response))

function checkStatus (response) {
  if (response) {
    return response
  } else {
    return {
      data: {
        status: 400,
        message: 'TimeOut Try Again Later'
      }
    }
  }
}

function checkCode (res) {
  if (isNormal(res)) {
    if (res && res.data && res.data.code === 100099) {
      window.location = '/login?message=' + res.data.message
      return
    }
  } else if (!res.data) {
    res.data = {
      status: '500',
      message: 'server error'
    }
  } else {
    res.data.status = 400
  }
  if (res && res.status === 400 && res.data.message === 'MISSING_NGTOKEN') {
    let url = window.location.href
    if (url.indexOf('login') < 0) {
      window.location = '/login'
      return
    }
  }
  return res.data
}

function isNormal (res) {
  if (res.data && res.data.message === 'OK' && res.data.error === '') {
    return true
  } else if (res.status === 200 && res.statusText === 'OK') {
    return true
  } else {
    return false
  }
}

export default {
  postJson (url, data) {
    let headers = {
      'Content-Type': 'application/json'
    }
    return axios({
      method: 'post',
      url,
      data,
      timeout: 30000,
      headers: headers
    }).then(checkStatus).then(checkCode)
  },
  post (url, data) {
    let headers = {
      'X-Requested-With': 'XMLHttpRequest'
    }
    return axios({
      method: 'post',
      url,
      data: qs.stringify(data),
      timeout: 30000,
      headers: headers
    }).then(checkStatus).then(checkCode)
  },
  get (url, params) {
    let headers = {
      'X-Requested-With': 'XMLHttpRequest'
    }
    return axios({
      method: 'get',
      url,
      params,
      timeout: 15000,
      headers: headers
    }).then(checkStatus).then(checkCode)
  },
  upload (url, data, uprogressFn) {
    return axios({
      method: 'post',
      url,
      data: data,
      timeout: 31000,
      onUploadProgress: uprogressFn,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(checkStatus).then(checkCode)
  },
  put (url, data) {
    let headers = {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
    return axios({
      method: 'put',
      url,
      data: qs.stringify(data),
      timeout: 30000,
      headers: headers
    }).then(checkStatus).then(checkCode)
  },
  delete (url, data) {
    let headers = {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
    return axios({
      method: 'delete',
      url,
      data: qs.stringify(data),
      timeout: 30000,
      headers: headers
    }).then(checkStatus).then(checkCode)
  }
}



// WEBPACK FOOTER //
// ./src/service/http.js